import Backbone from 'backbone';
import React from 'react';
import ReactDOM from 'react-dom';

import * as Analytics from 'analytics/Analytics';
import {ANALYTICS_MODULE, ActionOrigin, COMMON_ANALYTICS_ACTIONS} from 'constants/AnalyticsConstants';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';

import FileTabState from './FileTabState';
import FileView from './FileView';

export default class FileTabView extends Backbone.View<FileTabState> {
  static initClass(): void {
    this.prototype.className = 'buffer-tab buffer-tab--no-padding';
  }

  render(): this {
    const id = this.model.get('id');
    renderToDOM(<FileView id={id} />, this.el);
    Analytics.trackEventWithModule(
      COMMON_ANALYTICS_ACTIONS.VIEWED_WORKSPACE_ITEM,
      ANALYTICS_MODULE.INSIGHTS,
      {
        event_group_id: Analytics.makeAnalyticsEventId(),
        action_origin: ActionOrigin.UI_UNDETERMINED,
        viewed_object_id: id,
        viewed_object_type: 'file',
      }
    );
    return this;
  }

  remove(): Backbone.View<FileTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

FileTabView.initClass();
